import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import sidebarReducer from './slices/sidebarSlice';
import websiteSettingsReducer from './slices/websiteSettingsSlice';
import rolesReducer from './slices/rolesSlice';
import employeesReducer from './slices/employeesSlice';
import advancesReducer from './slices/advancesSlice';
import overtimeReducer from './slices/overtimeSlice';
import orgReducer from './slices/orgSlice';
import documentsReducer from './slices/documentsSlice';
import inboxReducer from './slices/inboxSlice';
import recruitmentReducer from './slices/recruitmentSlice';
import financialYearReducer from './slices/financialYearSlice';
import chatReducer from './slices/chatSlice';
import { ALL_MODULE_KEYS } from '../data/accessModules';

const PERSIST_KEY = 'ara_state_v1';
const PERSISTED_SLICES = ['roles', 'employees', 'advances', 'overtime', 'org', 'documents', 'inbox', 'recruitment', 'sidebar', 'websiteSettings', 'financialYear'];

const STATE_VERSION = 5;

const backfillAccess = (state) => {
    if (!state.roles?.roles) return state;
    return {
        ...state,
        roles: {
            ...state.roles,
            roles: state.roles.roles.map((role) => {
                const access = { ...role.access };
                ALL_MODULE_KEYS.forEach((k) => {
                    if (access[k] === undefined) access[k] = role.id === 'administrator';
                });
                return { ...role, access };
            }),
        },
    };
};

const MIGRATIONS = [
    (state) => state,

    backfillAccess,

    backfillAccess,

    backfillAccess,

    backfillAccess,
];

const loadState = () => {
    try {
        const raw = localStorage.getItem(PERSIST_KEY);
        if (!raw) return undefined;
        const parsed = JSON.parse(raw);
        const { __v = 0, ...data } = parsed;
        let migrated = data;
        for (let v = __v; v < STATE_VERSION; v += 1) {
            const step = MIGRATIONS[v];
            if (step) migrated = step(migrated) || migrated;
        }
        return migrated;
    } catch {
        return undefined;
    }
};

export const store = configureStore({
    reducer: {
        auth: authReducer,
        sidebar: sidebarReducer,
        websiteSettings: websiteSettingsReducer,
        roles: rolesReducer,
        employees: employeesReducer,
        advances: advancesReducer,
        overtime: overtimeReducer,
        org: orgReducer,
        documents: documentsReducer,
        inbox: inboxReducer,
        recruitment: recruitmentReducer,
        financialYear: financialYearReducer,
        chat: chatReducer,
    },
    preloadedState: loadState(),
});

let saveTimer = null;
store.subscribe(() => {
    if (saveTimer) return;
    saveTimer = setTimeout(() => {
        saveTimer = null;
        try {
            const state = store.getState();
            const slice = { __v: STATE_VERSION };
            PERSISTED_SLICES.forEach((k) => { slice[k] = state[k]; });
            localStorage.setItem(PERSIST_KEY, JSON.stringify(slice));
        } catch {
        }
    }, 400);
});

export default store;
